import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function SettingsTemplatesPage() {
  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: "default" }}
      resolvedSearchParams={{}}
      settingsView="templates"
    />
  );
}
